import { useEffect, useState } from 'react'
import { toast } from 'sonner'
import { twMerge } from 'tailwind-merge'

import { BannerWithTitle } from '@/components/banner-with-title'
import { Skeleton } from '@/components/skeleton'
import { useMediaQuery } from '@/hooks/use-media-query'
import api from '@/services/api'

import { GuardianCard } from './guardian-card'
import { GuardiansTestimonials } from './guardians-testimonials'

interface GuardianResponse {
  id_guardiao: string
  nome: string
  descricao: string
  url_obj: string
  url_site: string
}

export function Guardians() {
  const [guardians, setGuardians] = useState<GuardianResponse[] | null>(null)
  const [isLoadingGuardians, setIsLoadingGuardians] = useState<boolean>(true)

  const isDesktop = useMediaQuery('(min-width: 768px)')

  useEffect(() => {
    async function getGuardians() {
      await api
        .get<GuardianResponse[]>('/guardians')
        .then((response) => setGuardians(response.data))
        .catch((error) => toast.error(error.response.data.message))
        .finally(() => setIsLoadingGuardians(false))
    }
    getGuardians()
  }, [])

  return (
    <div className="content-container">
      <BannerWithTitle
        title="Conheça os Guardiões que protegem e impactam positivamente o planeta!"
        className="bg-guardians"
      />

      <main className="mt-10 space-y-16 xl:mt-16 2xl:mt-20 2xl:space-y-20">
        <h2 className="title">Conheça nossos guardiões</h2>
        <section>
          <div
            className={twMerge(
              'items-center justify-center sm:flex',
              !isDesktop && 'overflow-x-auto',
            )}
          >
            <div
              className={twMerge(
                'flex gap-10 md:grid lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4',
                !isDesktop && 'w-max',
              )}
            >
              {isLoadingGuardians &&
                Array.from({ length: 6 }).map((_, index) => (
                  <Skeleton
                    className="h-60 w-[90vw] rounded-2xl shadow-lg lg:w-92 2xl:w-100"
                    key={index}
                  />
                ))}

              {guardians?.map((guardian) => (
                <div
                  className="flex flex-col-reverse gap-4 lg:flex-col"
                  key={guardian.id_guardiao}
                >
                  <GuardianCard
                    nome={guardian.nome}
                    descricao={guardian.descricao}
                    url_obj={guardian.url_obj}
                    url_site={guardian.url_site}
                  />
                </div>
              ))}
            </div>
          </div>
        </section>

        <GuardiansTestimonials />
      </main>
    </div>
  )
}
